import React, { useEffect } from "react";
import { useAppContext } from "../../../hooks/useAppContext";
import { showDialogAsync } from "../../dialog-queue";
import { IFrameDialog } from "../../dialog/iframe";
import { waitForPendingUploadsAsync } from "../pending-uploads-dialog";

/** Return true on login, undefined on close/cancel */
export const showLoginDialogAsync = (
	// eslint-disable-next-line @typescript-eslint/default-param-last
	loginflow: eXpress.creator.LoginFlow = eXpress.creator.LoginFlow.Default,
	{
		editor,
	}: {
		editor: eXpress.core.IEditor;
	},
) =>
	waitForPendingUploadsAsync({
		getHasPendingUploads: () => editor.hasPendingUploads(false),
	}).then((hasFinishedUploading) =>
		hasFinishedUploading
			? showDialogAsync<true | undefined>(({ resolve }, { isOpen }) => {
					const {
						googleAnalytics,
						context: { homeUrl },
					} = useAppContext();

					useEffect(() => {
						const onLogin = () => {
							googleAnalytics.trackEventToGa({
								trackingAction: "LoggedIn",
							});
							resolve(true);
						};
						document.addEventListener("loggedOn.loginDialog", onLogin);

						const onClose = (event: any) => {
							if (!event.data || event.data.command !== "CloseLoginPopup") return;

							resolve(undefined); // close the popup
						};
						// iframe with login popup has its own close icon that triggers a message with command: 'CloseLoginPopup'
						window.addEventListener("message", onClose);

						return () => {
							document.removeEventListener("loggedOn.loginDialog", onLogin);
							window.removeEventListener("message", onLogin);
						};
					}, [googleAnalytics, resolve]);

					const url = `${homeUrl}login.aspx?embed&flow=${loginflow}`;
					return <IFrameDialog isOpen={isOpen} url={url} iframeTitle="login" />;
			  })
			: undefined,
	);
